import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'primary' | 'forest';
  onClick?: () => void;
};
export function Button({
  children,
  href,
  className = '',
  fullWidth,
  variant = 'primary',
  onClick
}: ButtonProps) {
  const external = !href.startsWith('#');
  const palette = variant === 'forest' ? 'bg-ink text-white shadow-[0_14px_30px_rgba(19,64,47,.28)] hover:bg-forest' : 'bg-primary text-white shadow-[0_14px_30px_rgba(226,85,44,.32)] hover:bg-primary-dark';
  return <motion.a href={href} onClick={onClick} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex items-center justify-center rounded-xl px-7 py-4 text-center text-base font-extrabold uppercase tracking-wide transition-colors duration-150 ease-out focus:outline-none focus:ring-4 focus:ring-primary/30 ${palette} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-252" data-mp="1eji35sq1k6wk">
      {children}
    </motion.a>;
}